import { Component, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DataStorageService } from '../../services/data-storage.service';
import { PetInsuranceData } from "../../models";
import { Observable, Subject, takeUntil } from "rxjs";
import { EditInsuranceInfoComponent } from "../../modules/insurance/edit-insurance-info/edit-insurance-info.component"; // Assuming the path

@Component({
  selector: 'cpf-edit-insurance-info-page',
  templateUrl: './edit-insurance-info-page.component.html',
  styleUrls: ['./edit-insurance-info-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class EditInsuranceInfoPageComponent implements OnDestroy {
  @ViewChild(EditInsuranceInfoComponent) editInsuranceInfoComponent?: EditInsuranceInfoComponent;


  petData?: PetInsuranceData;
  private destroy$ = new Subject<void>();

  constructor(private dataStorageService: DataStorageService) {
    this.setPetData();

    this.dataStorageService.selectedData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (data) {
        this.petData = data;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setPetData() {
    const selectedData = this.dataStorageService.selectedData;

    if (selectedData) {
      this.petData = selectedData;
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.editInsuranceInfoComponent?.canDeactivate() ?? true;
  }
}
